import { createAsyncThunk } from '@reduxjs/toolkit';

import { bookTagApi } from '~/api/book/bookTagApi';
import {
  GetTagBySlugParams, GetTagBySlugRsult, SearchTagsParams,
} from '~/api/book/bookTagApiTypes';
import { baseFrontServerUrl } from '~/api/provider/provider.config';
import { tagActions } from '~/feature/tag/tag.slice';

export const searchTag = createAsyncThunk<
void,
SearchTagsParams,
{ rejectValue: { error: string }; }
>(
  'tag/searchTag',
  async (
    data,
    thunkAPI,
  ) => {
    try {
      const result = await bookTagApi.searchTags(data);
      if (result && 'data' in result) {
        thunkAPI.dispatch(tagActions.changeTags(result.data));
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);

export const getTagBySlug = createAsyncThunk<
GetTagBySlugRsult,
GetTagBySlugParams,
{ rejectValue: { error: string }; }
>(
  'tag/getTagBySlug',
  async (
    { slug },
    thunkAPI,
  ) => {
    try {
      thunkAPI.dispatch(tagActions.setIsCurrentTagLoading(true));
      const result = await bookTagApi.getTagBySlug({ slug });

      if (result && 'data' in result) {
        thunkAPI.dispatch(tagActions.changeCurrentTag(result.data));
        thunkAPI.dispatch(tagActions.changeRelatedTags(
          result.relatedTags
            .map((tag) => ({ ...tag, url: `${baseFrontServerUrl}/tag/${tag.slug}` })),
        ));
        thunkAPI.dispatch(tagActions.changeCurrentTagSeo(result.seo));
        return result;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    } finally {
      thunkAPI.dispatch(tagActions.setIsCurrentTagLoading(false));
    }
  },
);
